<template>
  <div>
    <CompoundQuery
      ref="query"
      @search="handleSearch"
    />
    <div v-if="list.length > 0">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="cus-info"
      >
        <div class="cus-info-header">
          <div class="cus-info-header-left">
            <img
              v-if="item.icon_url"
              :src="item.icon_url"
            >
            <i
              v-else
              class="crm-icon-box cus-default"
            />
            <span
              style="cursor: pointer"
              @click="showDetail(item)"
            >
              {{ item.product_name }}
            </span>  
          </div>
          <div>
            <Button
              type="primary"
              @click="showDetail(item)"
            >
              查看详情
            </Button>
            <Button
              @click="exportPublic(item)"
            >
              释放到公海
            </Button>
          </div>
        </div>
        <div class="cus-info-body">
          <div class="cus-info-body-left">
            <div class="cus-row">
              <div class="cus-col">
                <div class="cus-label">广告公司名称</div>
                <div class="cus-value">{{ item.company }}</div>
              </div>
              <div class="cus-col">
                <div class="cus-label">释放时间</div>
                <Tooltip :content="`${item.over_at}释放`">
                  <div class="cus-value">{{ item.over_day > 30 ? 30 : item.over_day }}天后释放</div>
                </Tooltip>
              </div>
              <div class="cus-col">
                <div class="cus-label">直客销售</div>
                <div class="cus-value">{{ item.username }}</div>
              </div>
              <div class="cus-col">
                <div class="cus-label">客户编号</div>
                <div class="cus-value">{{ item.customer_id }}</div>
              </div>
            </div>
            <div class="cus-row">
              <div class="cus-col">
                <div class="cus-label">最近一次消耗时间</div>
                <div class="cus-value">{{ item.last_cost_time }}</div>
              </div>
              <div class="cus-col">
                <div class="cus-label">归属时间</div>
                <div class="cus-value">{{ item.owner_at }}</div>
              </div>
              <div class="cus-col">
                <div class="cus-label">品牌</div>
                <div class="cus-value">{{ getBrand(item.brand) }}</div>
              </div>
              <div class="cus-col">
                <div class="cus-label">广告账号数</div>
                <div class="cus-value">{{ item.account_num }}个</div>
              </div>
            </div>
          </div>
          <div class="cus-info-body-right">
            <Chart
              :customerId="item.customer_id"
              :productId="item.product_id"
            />
          </div>
        </div>
      </div>
    </div>

    <Empty
      v-else
      style="margin-bottom: 20px"
      tips="没有数据"
    />

    <Pagination
      style="float: right"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { Button, Tooltip, Pagination } from 'element-ui';
import { find } from 'lodash';

import CompoundQuery from './components/CompoundQuery';
import Chart from './components/Chart';
import Empty from '@/components/Empty';

import requestMixin from './mixins/request';

export default {
  components: {
    Button,
    Tooltip,
    Pagination,

    CompoundQuery,
    Chart,
    Empty,
  },

  mixins: [requestMixin],

  data() {
    return {
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      brands: [],
    };
  },

  created() {
    this.customerMyCustomerList();
    this.getBrands();
  },

  methods: {
    handleSearch(params) {
      this.page = 1;
      this.customerMyCustomerList(params);
    },

    handleSizeChange(size) {
      this.pageSize = size;
      const params = this.$refs.query.getParams();
      this.customerMyCustomerList(params);
    },

    handleCurrentChange(current) {
      this.page = current;
      const params = this.$refs.query.getParams();
      this.customerMyCustomerList(params);
    },

    showDetail(item) {
      if (!item.customer_id) return;
      const router = this.$router.resolve({
        path: '/advertiser-manage/detail',
        query: {
          customerId: item.customer_id,
          type: '1',
          owner: item.user_id,
        },
      });
      window.open(router.href, '_blank');
    },

    exportPublic(item) {
      const title = `请确认是否释放 <br/>【${item.product_name}】？`;
      this.$confirm(title, '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确认，释放',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        this.exportToPublic(item);
      });
    },

    getBrand(id) {
      const res = find(this.brands, (brand) => {
        return brand.id === id;
      });
      return res ? res.name : '其他';
    },
  },
};
</script>

<style lang="less" scoped>
.cus {
  &-default {
    width: 24px;
    height: 24px;
    background: rgba(220, 223, 230, 1);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin-right: 8px;
  }

  &-row {
    flex: 1;
  }

  &-col {
    display: flex;
    font-size: 14px;
    padding: 12px 0;
  }

  &-label {
    flex: 0 0 30%;
    color: #909399;
    text-align: right;
    margin-right: 20px;
  }
}
.cus-info {
  box-sizing: border-box;
  padding: 28px;
  width: 100%;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 1px solid rgba(220, 223, 230, 1);
  margin-bottom: 24px;

  &-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;

    &-left {
      display: flex;
      align-items: center;

      & > img {
        width: 24px;
        margin-right: 8px;
      }

      & > span {
        font-size: 24px;
        color: #2f9eff;
      }
    }
  }

  &-body {
    margin-top: 32px;
    display: flex;

    &-left {
      flex: 2;
      display: flex;
    }

    &-right {
      flex: 1;
    }
  }
}
</style>